module.exports = __webpack_public_path__ + "static/img/detailImgfj.3ce24ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/detailImgfj.jpg
// module id = zeg2
// module chunks = 5